import React, { Fragment, useEffect, useState } from 'react';
import { default as logoSrc } from '../../assets/images/grayledlearns.png';
import { useDispatch, useSelector } from 'react-redux';
import arrow_down from '../../assets/images/angle_up_down.svg';

import { default as ArrowDown } from '../../assets/images/angle_up_down.svg';
import SideBarHeader from '../studentDashboard/SideBarHeader/SideBarHeader';
import BookParagraph from '../../Pages/BookParagraph';
import { getBook } from '../../Store/api/student';
import { byBook } from '../../Store/api/activities';
import HtmlAsText from '../createmode/HtmlAsText';
import StudentBookContent from './studentBookContent';
const StudentGradSidebar = ({ setIsBookExpanded, tabConent, setTabs, bookId, activity, reCenter = false, scrollChapter = () => {} }) => {
  // const {book, books} = useSelector((state) => state.entities);
  const { book } = useSelector((state) => state.entities.student);
  // const [tabConent, setTabs] = useState("book");
  const [sideBar, setSideBar] = useState([]);
  const [sideBarSection, setSideBarSection] = useState([]);
  const [subTab, setSubTab] = useState('all');
  const [sideBarActivity, setSideBarActivity] = useState([]);
  const [activities, setActivities] = useState([]);
  const [scrollId, setScrollId] = useState('');

  const dispatch = useDispatch();
  useEffect(() => {
    if (bookId) {
      dispatch(
        getBook({
          id: bookId,
          onSuccess: (res) => {},
          onError: () => {},
        })
      );
    }
  }, [bookId]);

  const dynamicChapterClass = (chapter, index) => {
    let className = 'accordion-button main_head chapter_element chapter-btn chapter_element_left';
    className += sideBar.includes(chapter.title) ? ' active' : ' collapsed';
    return className;
  };

  const dynamicSectionClass = (chapter, section, index, secIndex) => {
    let className = 'section-btn section_element section_element_left';

    className += sideBarSection.includes(`${chapter._id}-${section._id}`) ? ' accordion-button main_head active' : ' accordion-button main_head collapsed';
    return className;
  };
  const toggleSidebarSection = (e, value) => {
    e.stopPropagation();
    if (sideBarSection.includes(value)) {
      setSideBarSection(sideBarSection.filter((sec) => sec !== value));
    } else {
      setSideBarSection([...sideBarSection, value]);
    }
  };
  const toggleSidebarActivity = (e, value) => {
    if (sideBarActivity.includes(value)) {
      setSideBarActivity(sideBarActivity.filter((e) => e !== value));
    } else {
      setSideBarActivity([...sideBarActivity, value]);
    }
  };

  const expendSidebar = (e, value) => {
    e.stopPropagation();
    if (sideBar.includes(value)) {
      setSideBar(sideBar.filter((e) => e !== value));
    } else {
      setSideBar([...sideBar, value]);
    }
  };

  useEffect(() => {
    if (reCenter) {
      let id = activity?.chapter;

      if (activity?.section) id += `.${activity.section}`;
      if (activity?.paragraphs?.length > 0) id += `.${activity.paragraphs?.[0]}`;
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  }, [reCenter, activity]);

  const renderChapters = () => {
    return (
      <div className='tab-pane fade show active custom_tabs_chapater '>
        <div className='accordion ' id='accordion_active' style={{ marginTop: '0px' }}>
          {book.chapters.map((chapter, index) => {
            const chapActivities = book.activities.filter((e) => e.chapter === chapter._id && !e.section);
            const chapActivity = chapActivities[0];
            return (
              <div key={index} style={{ paddingLeft: '12px' }}>
                <div className={`accordion-item`}>
                  <h2
                    className='accordion-header'
                    // id="panelsStayOpen-Preface"
                  >
                    <div
                      className={dynamicChapterClass(chapter, index)}
                      type='button'
                      aria-expanded={sideBar.includes(chapter.title) ? true : false}
                      aria-controls='panelsStayOpen-collapsePreface'
                      data-id={chapter._id}
                      onClick={() => {
                        setScrollId(chapter._id);
                        setIsBookExpanded(false);
                      }}
                      style={{ padding: '0px 8px' }}
                    >
                      {'    '}{' '}
                      <div
                        style={{ padding: '4px  6px', borderRadius: '2px' }}
                        // className="chap_title bg_grey"
                        className={`chap_title ${sideBar.includes(chapter?.title) ? 'bg_grey' : ''}`}
                      >
                        <span className='eclipses'>
                          <HtmlAsText htmlContent={chapter?.title} />
                        </span>
                        {chapter?.sections?.length > 0 && (
                          <img
                            src={ArrowDown}
                            alt='arrow'
                            onClick={(e) => {
                              chapter.sections.length && expendSidebar(e, chapter.title);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </h2>

                  <div
                    style={{ marginBottom: '8px' }}
                    // id="panelsStayOpen-collapsePreface"
                    className={sideBar.includes(chapter.title) ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'}
                    aria-labelledby='panelsStayOpen-Preface'
                  >
                    {/* <div className="accordion-body">
                      <p className="f14">{chapter.description}</p>
                    </div> */}
                    <div
                      className='accordion-body bl'
                      style={{
                        marginTop: '10px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                      }}
                    >
                      {book.activities
                        .filter((e) => e.chapter?._id === chapter?._id && !e.section)
                        .map((e, index) => (
                          <div key={index} className='section_element'>
                            <div className='accordion-item'>
                              <h2 className='accordion-header'>
                                <button
                                  style={{
                                    textTransform: 'capitalize',
                                    margin: '0px 1px 0px 16px',
                                    padding: '0px 0px',
                                    fontWeight: '400',
                                  }}
                                  className={dynamicChapterClass(chapter, index)}
                                  data-id={`${chapter._id}`}
                                  type='button'
                                  data-bs-toggle='collapse'
                                  aria-expanded={sideBarSection.includes(`${chapter._id}`)}
                                >
                                  <div
                                    className='purple'
                                    style={{ fontWeight: '400' }}
                                    onClick={(e) => {
                                      scrollChapter(chapter?._id);
                                      toggleSidebarSection(e, `${chapter._id}`);
                                    }}
                                  >
                                    <HtmlAsText htmlContent={e.title} style={{ fontWeight: '400' }} />
                                  </div>{' '}
                                </button>
                              </h2>
                            </div>
                          </div>
                        ))}
                      {chapter.sections.map((section, secIndex) => {
                        const sectActivities = book.activities.filter((e) => e.section === section._id && !e.paragraphs.length);
                        const sectActivity = sectActivities[0];
                        return (
                          <div key={secIndex} className='section_element'>
                            <div className='accordion-item'>
                              <h2
                                className='accordion-header'
                                // id="panelsStayOpen-Biological"
                              >
                                <button
                                  className={dynamicSectionClass(chapter, section, index, secIndex)}
                                  onClick={() => {
                                    setScrollId(chapter._id + '.' + section._id);
                                    setIsBookExpanded(false);
                                  }}
                                  style={{
                                    textTransform: 'capitalize',
                                    margin: '0px 1px 0px 16px',
                                    padding: '3px 0px',
                                  }}
                                  data-id={`${chapter._id}.${section._id}`}
                                  type='button'
                                  data-bs-toggle='collapse'
                                  aria-expanded={sideBarSection.includes(`${chapter._id}-${section._id}`)}
                                >
                                  <div
                                    className='chap_title'
                                    // onClick={(e) =>
                                    //   scrollSection(secIndex, index)
                                    // }
                                  >
                                    <span className='eclipses sects'>
                                      <HtmlAsText htmlContent={section.title} />
                                    </span>
                                    {(book.activities.some((e) => (typeof e.section === 'object' ? e.section._id : e.section) === section._id && !e.paragraph) || section?.paragraphs?.some((p) => book.activities.some((e) => e.paragraphs?.some((par) => (typeof par === 'object' ? par._id : par) === p._id)))) && <img onClick={(e) => toggleSidebarSection(e, `${chapter._id}-${section._id}`)} src={sideBarSection.includes(`${chapter._id}-${section._id}`) ? arrow_down : arrow_down} alt='arrow' style={{ cursor: 'pointer' }} />}

                                    {/* <img onClick={(e) => toggleSidebarSection(e, `${chapter._id}-${section._id}`)} src={arrow_down} alt='arrow' /> */}
                                  </div>{' '}
                                </button>
                                {
                                  // Check if activity matches this section OR any of its paragraphs
                                  (book.activities.some((e) => (typeof e.section === 'object' ? e.section._id : e.section) === section._id && !e.paragraph) || section?.paragraphs?.some((p) => book.activities.some((e) => e.paragraphs?.some((par) => (typeof par === 'object' ? par._id : par) === p._id)))) && (
                                    <div className={sideBarSection.includes(`${chapter._id}-${section._id}`) ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'} aria-labelledby='panelsStayOpen-Biological'>
                                      <div
                                        className='accordion-body bl'
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: '8px',
                                        }}
                                      >
                                        {book.activities
                                          .filter((e) => (typeof e.section === 'object' ? e.section._id : e.section) === section._id && !e.paragraph)
                                          .map((e, index) => (
                                            <div key={index} className='section_element'>
                                              <div className='accordion-item'>
                                                <h2 className='accordion-header'>
                                                  <button
                                                    style={{
                                                      textTransform: 'capitalize',
                                                      margin: '0px 1px 0px 16px',
                                                      padding: '0px 0px',
                                                      fontWeight: '400',
                                                    }}
                                                    className={dynamicSectionClass(section, section, index)}
                                                    data-id={`${section._id}`}
                                                    type='button'
                                                    data-bs-toggle='collapse'
                                                    aria-expanded={sideBarSection.includes(`${chapter._id}-${section._id}`)}
                                                  >
                                                    <div
                                                      className='purple'
                                                      style={{ fontWeight: '400' }}
                                                      onClick={(e) => {
                                                        toggleSidebarSection(e, `${chapter._id}.${section._id}`);
                                                        setScrollId(`${chapter._id}.${section._id}`);
                                                        setIsBookExpanded(false);
                                                      }}
                                                    >
                                                      <HtmlAsText htmlContent={e.title} style={{ fontWeight: '400' }} />
                                                    </div>
                                                  </button>
                                                </h2>
                                              </div>
                                            </div>
                                          ))}
                                      </div>
                                    </div>
                                  )
                                }
                              </h2>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderNewActivities = () => {
    return (
      <div className='Contents_tabs custom_tabs_chapater'>
        {' '}
        {book.activities.map((activity, actIndex) => (
          <div className='accordion-item activity-element' key={activity.chapter + '.' + activity.section + '.' + actIndex}>
            <h2 className='accordion-header activity-element'>
              <div
                // className={
                //   sideBarActivity.includes(`${chapter._id}-${section._id}-${activity._id}`) ? "accordion-button active main_head fw_700" : "accordion-button collapsed main_head fw_700"
                // }
                className={`${sideBarActivity.includes(`${activity.chapter}-${activity.section}-${activity._id}`) ? 'accordion-button active main_head fw_700' : 'accordion-button main_head fw_700 collapsed'} ${activity.assigned ? 'assigned' : ''} activity-btn activity-element`}
                type='button'
                data-bs-toggle='collapse'
                data-bs-target='#panelsStayOpen-collapseKnowledge'
                aria-expanded={sideBarActivity.includes(`${activity.chapter}-${activity.section}-${activity._id}`)}
                aria-controls='panelsStayOpen-collapseKnowledge'
                onClick={(e) => {
                  toggleSidebarActivity(e, `${activity.chapter}-${activity.section}-${activity._id}`);
                }}
              >
                <div className='chap_title activity-element'>
                  {' '}
                  <span className='eclipses'>
                    <HtmlAsText htmlContent={activity.title} />

                    {/* {activity.title} */}
                  </span>
                  <img src={arrow_down} alt='arrow' className='activity-element' />
                </div>{' '}
              </div>
            </h2>

            <div
              // id="panelsStayOpen-collapseSubdisciplines"
              className={sideBarActivity.includes(`${activity.chapter}-${activity.section}-${activity._id}`) ? 'accordion-collapse collapse event-less show' : 'accordion-collapse collapse event-less'}
              aria-labelledby='panelsStayOpen-Subdisciplines'
            >
              <div className='accordion-body event-less'>
                {activity.questions.map((question, quesIndex) => (
                  <div key={quesIndex} className='event-less'>
                    <p className='event-less'>
                      <a href='#!' className='event-less'>
                        {question.text}
                      </a>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className='custom_nav' style={{ marginTop: '0px' }}>
      <img src={logoSrc} alt='logo' style={{ marginBottom: '32px', padding: '0px 24px' }} />
      <div style={{ padding: '0px 24px' }}>
        <ul className='nav nav-tabs nav-justified' id='myTab' role='tablist'>
          <li className='nav-item' role='presentation'>
            <button
              className={tabConent === 'content' ? 'nav-link active' : 'nav-link'}
              id='home-tab'
              data-bs-toggle='tab'
              data-bs-target='#Contents'
              type='button'
              role='tab'
              aria-controls='Contents'
              aria-selected='true'
              onClick={(e) => {
                setIsBookExpanded(true);
                setTabs('content');
              }}
            >
              Contents
            </button>
          </li>
          <li className='nav-item' role='presentation'>
            <button
              className={tabConent === 'book' ? 'nav-link active' : 'nav-link'}
              id='classroom-tab'
              data-bs-toggle='tab'
              data-bs-target='#classroom'
              type='button'
              role='tab'
              aria-controls='profile'
              aria-selected='false'
              onClick={(e) => {
                setIsBookExpanded(false);
                setTabs('book');
              }}
            >
              book
            </button>
          </li>
        </ul>
      </div>
      <div className='tab-content' id='myTabContent'>
        <div className={tabConent === 'content' ? 'tab-pane fade show active' : 'tab-pane fade show'} id='Contents' role='tabpanel' aria-labelledby='Contents-tab'>
          <StudentBookContent book={book} subTab={subTab} renderChapters={renderChapters} renderNewActivities={renderNewActivities} mode={'studentFocusedMode'} setIsBookExpanded={setIsBookExpanded} />
          <>
            {/* <div className="Contents_tabs">
            <div className="tabs_content classroom_wrap" id="myContents">
              {subTab === "activities-chapters" ? (
                <Fragment>
                  <div className="vh-50">
                    <div
                      className="tab-pane fade show active custom_tabs_chapater"
                      aria-labelledby="all-tab"
                    >
                      {renderChapters()}
                    </div>
                  </div>
                  <div className="sidebar_subheading">
                    <span> ACTIVITIES</span>
                  </div>
                  <hr />
                  <div className="vh-50">{renderNewActivities}</div>
                </Fragment>
              ) : (
                <Fragment>
                  <div
                    className="tab-pane fade show active custom_tabs_chapater"
                    aria-labelledby="all-tab"
                  >
                  
                    {renderChapters()}
                  </div>
                </Fragment>
              )}
            </div>

            <ul
              className="nav nav-tabs grade_mode"
              id="myContents_two"
              role="tablist"
            >
             
            </ul>
          </div> */}
          </>
        </div>
        <div className={tabConent === 'book' ? 'tab-pane fade show active sidebar_book' : 'tab-pane fade show sidebar_book'} id='book' role='tabpanel' aria-labelledby='book-tab'>
          <SideBarHeader />
          <div className=''>
            <BookParagraph bookId={bookId} activity={activity} setTabs={setTabs} scrollId={scrollId} setScrollId={setScrollId} chapters={book.chapters} activities={activities} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default StudentGradSidebar;
